module.exports = __webpack_public_path__ + "img/HeadExtraction01.46d6bb74.png";